<tt-card>
    <ng-content></ng-content>
    <hr class="tt-card__hr" />
    <tt-content-switcher ttRememberId="w_pictures.listview" ttOnlyRemember ttStretchWidth="false" [(ttSelectedId)]="page.view">
        <tt-switch ttId="grid" ttIcon="far fa-th" ttText="gridview"></tt-switch>
        <tt-switch ttId="list" ttIcon="far fa-list" ttText="listview"></tt-switch>
    </tt-content-switcher>
    <div class="pictures-grid" [class.pictures-list]="page.view === 'list'">
        <tt-picture-card *ngFor="let picture of pictures; trackBy: trackByPicture" [picture]="picture" [view]="page.view" [argtype]="page.argtype" [argvalue]="page.argvalue"></tt-picture-card>
        <div *ngFor="let skeleton of skeletons" class="pictures-skeleton" [class.pictures-skeleton--list]="page.view === 'list'" aria-hidden="true">
            <span class="tt-skeleton pictures-skeleton__image"></span>
            <span *ngIf="page.view === 'list'" class="pictures-skeleton__details">
                <span class="tt-skeleton"></span>
                <span class="tt-skeleton"></span>
            </span>
        </div>
    </div>
</tt-card>

<tt-pager [ttPageIndex]="+page.pageindex" [ttPageSize]="+page.pagesize" [ttTotalCount]="+page.total" ttKeepPageIndexOnSizeChange (ttPageChange)="onPageChange($event)"></tt-pager>
